<template>
  <section>
    <p>
      当番組は閉鎖致しました。<br>
      大変長らくご愛顧頂き誠にありがとうございます。<br>
      お問い合わせは下記のメールアドレスにお送り下さい。
    </p>
    <p>運営事務局：info@weebb.jp</p>
  </section>
</template>

<script>
export default {
  name: 'RestrictionBlack',
  data () {
    return {
      user: this.$store.getters.loginUser || null,
      info: this.$store.getters.siteInfo || null
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    },
    siteInfo () {
      return this.$store.getters.siteInfo
    }
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    },
    siteInfo (val, old) {
      this.info = val
    }
  }
}
</script>
